import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class AdmClientesUsuariosService extends Service{

  protected url: string = this.dominio+"/adm/clientes-usuarios/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  getById(id){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id+'/?relations=["status","pais","unidade"]', {headers})
      .map(res => {
        var json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  solicitarNovaSenha(email){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http
      .get(
        this.dominio+"/pub/clientes-usuarios/nova-senha/"+email,
        { headers }
      )
      .map(res => {
        var json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  atualizarIdioma(lang){
    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.dominio+"/adm/clientes-usuarios/upd-lang/"+lang+"/", {},
        { headers }
      )
      .map(res => {
        var json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  confirmarCadastro(elem){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.dominio +'/pub/clientes-usuarios/ativar-cadastro', JSON.stringify(elem), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  salvarNovaSenha(elem){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.dominio +'/pub/clientes-usuarios/salvar-nova-senha', JSON.stringify(elem), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  timezone(){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.get(this.dominio +'/pub/timezone', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }


  setStatus(id_usuario, id_status){

    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.dominio+"/adm/clientes-usuarios/"+id_usuario+"/status/"+id_status+"/", {},
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getListStatus(){
    let headers = this.getHeaderLogado();

    return this.http
      .get(
        this.dominio+"/adm/clientes-usuarios/status",
        { headers }
      )
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/clientes-usuarios/adm-clientes-usuarios.service.ts